<template>
    <div class="product-detail">

        <header class="blue filter">
            <div class="container">
                <div class="row"></div>
            </div>
        </header>

        <section class="breadcrumbs">
            <div class="container">
                <router-link :to="'/filter'">{{'Products' | translate}}</router-link>
                <span> > </span>
                <span> {{ getProp(material, "title") }}</span>
            </div>
        </section>

        <article class="main">
            <div class="container">
                <div class="row">
                    <aside class="col-md-4">
                        
                        <section class="no-border" v-if="material.product_image">
                            <img :src="material.product_image" alt="">
                        </section>
                        
                        <section class="no-border">
                            <header>
                                <h4>
                                    {{'Selecting gaskets with pT diagrams' | translate}}
                                </h4>
                            </header>
                            <p>
                                {{'Maximum temperature and pressure values alone can not define a material’s suitability for an application. These limits are dependent upon a multiplicity of factors like flanges, bolts, installation, process control, fluctuating loads an so on. The pT diagram therefore provides only guidelines.' | translate}}
                            </p>
                        </section>

                        <section class="no-border" v-if="material.chart_image">
                            <header>
                                <h3>{{'pT-diagram' | translate}}</h3> <small>{{'- thickness'| translate}} {{["30", "32"].includes(material.id) ? '1.5 mm' : '2.0 mm'}}</small></h3>
                            </header>

                            <img :src="material.chart_image" alt="">

                            <section class="pt">
                                <p>
                                    <strong>{{'In area one'| translate}}</strong>, {{'the gasket material is normally suitable subject to chemical compatibility'| translate}}.
                                </p>
                                <p>
                                    <strong>{{'In area two'| translate}}</strong>, {{'the gasket material may be suitable but a technical evaluation is recommended'| translate}}.
                                </p>
                                <p>
                                    <strong>{{'In area three'| translate}}</strong>, {{'do not install the gasket without a technical evaluation. Always refer to the chemical resistance of the gasket to the media.'| translate}}
                                </p>
                                <small v-if="$root.locale === 'de_DE'">
                                    Für die anwendungstechnische Überprüfung empfehlen wir die Verwendung des
                                    Dichtungsberechnungsprogrammes <a href="https://www.klinger.co.at/de/services/downloads?file=files/KLINGER_Dichtungstechnik/downloads/Produktinformation%20allgemein/KLINGERexpert%206.0_D.pdf&cid=1666" target="_blank">KLINGER®expert</a>. Diese leistungsfähige
                                    Software unterstützt den Benutzer bei der Auswahl von nichtmetallischen
                                    Dichtungen. Bitte registrieren Sie sich für den download: <a href="https://www.klinger.co.at/de/services/klinger-expert" target="_blank">KLINGER®expert</a>
                                </small>
                                <small v-else>
                                    For technical evaluation use <a href="/files/KLINGER_Dichtungstechnik/downloads/KLINGERexpert 6.0_E.pdf" target="_blank">KLINGER®expert</a> gasket design program.

                                    This is a versatile software to assist users in the selection of

                                    non- metallic gasket material.

                                    Please register for download: <a href="https://www.klinger.co.at/en/services/klinger-expert" target="_blank">KLINGER®expert</a>.
                                </small>
                            </section>
                        </section>

                    </aside>

                    <main class="col-md-8">
                        <div class="row">
                            <div class="col-md-8">
                                <header>
                                    <h1>{{ getProp(material, 'title') }}</h1>
                                </header>

                                <section class="desc" v-html="getProp(material, 'description')"></section>

                                <section class="row desc">
                                    <div class="col-md-6">
                                        <h5>{{'Certificates:' | translate}}</h5>
                                        <ul>
                                            <li v-for="structure in material.certificates">
                                                {{ getProp(structure, 'title') }}
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col-md-6" v-if="material.industries.length">
                                        <h5>{{'Industries:' | translate}}</h5>
                                        <ul>
                                            <li v-for="structure in material.industries">
                                                {{ getProp(structure, 'title') }}
                                            </li>
                                        </ul>
                                    </div>
                                </section>


                                <section class="buy">
                                    <a target="_blank" :href="'https://www.klinger.co.at' + ($root.locale !== 'de_DE' ? '/en/company/sales-partner' : '/de/unternehmen/vertriebspartner')" class="buy-button">
                                        <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="shopping-cart" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-shopping-cart fa-w-18 fa-9x"><path fill="currentColor" d="M551.991 64H144.28l-8.726-44.608C133.35 8.128 123.478 0 112 0H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h80.24l69.594 355.701C150.796 415.201 144 430.802 144 448c0 35.346 28.654 64 64 64s64-28.654 64-64a63.681 63.681 0 0 0-8.583-32h145.167a63.681 63.681 0 0 0-8.583 32c0 35.346 28.654 64 64 64 35.346 0 64-28.654 64-64 0-18.136-7.556-34.496-19.676-46.142l1.035-4.757c3.254-14.96-8.142-29.101-23.452-29.101H203.76l-9.39-48h312.405c11.29 0 21.054-7.869 23.452-18.902l45.216-208C578.695 78.139 567.299 64 551.991 64zM208 472c-13.234 0-24-10.766-24-24s10.766-24 24-24 24 10.766 24 24-10.766 24-24 24zm256 0c-13.234 0-24-10.766-24-24s10.766-24 24-24 24 10.766 24 24-10.766 24-24 24zm23.438-200H184.98l-31.31-160h368.548l-34.78 160z" class=""></path></svg>
                                        {{'Sales partner' | translate}}
                                    </a>
                                </section>


                            </div>
                            <div class="col-md-4 aside">

                                 <section class="download">
                                    <header>
                                        <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="file-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="svg-inline--fa fa-file-alt fa-w-12 fa-9x"><path fill="currentColor" d="M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1C264.8 0 277 5.1 286 14.1L369.9 98c9 8.9 14.1 21.2 14.1 33.9zm-128-80V128h76.1L256 51.9zM336 464V176H232c-13.3 0-24-10.7-24-24V48H48v416h288z" class=""></path></svg>
                                        <h3>{{'PDF download' | translate}}</h3>
                                    </header>
                                    <ul>
                                        <li v-if="getProp(material, 'pdf')">
                                            <a target="blank" v-bind:href="getProp(material, 'pdf')">{{'Product documentation' | translate}}</a>
                                        </li>
                                        <li v-if="getProp(material, 'pdf_shelf')">
                                            <a target="blank" v-bind:href="getProp(material, 'pdf_shelf')">{{'Shelf life' | translate}}</a>
                                        </li>
                                        <li v-if="getProp(material, 'pdf_safety')">
                                             <a target="blank" v-bind:href="getProp(material, 'pdf_safety')">{{'Safety information' | translate}}</a>
                                        </li>
                                        <li v-if="getProp(material, 'pdf_manual')">
                                            <a target="blank" v-bind:href="getProp(material, 'pdf_manual')">{{'Installation manual' | translate}}</a>
                                        </li>
                                        <li>
                                            <a :href="$root.locale === 'de_DE' ? 'https://www.klinger.co.at/de/services/downloads?file=files/KLINGER_Dichtungstechnik/downloads/dichtungsfaktoren/Gasket_Factors_DE.pdf&cid=1667' : '/files/KLINGER_Dichtungstechnik/downloads/Gasket_Factors_EN.pdf'" target="_blank">{{'Gasket factors' | translate}}</a>
                                        </li>
                                        <li>
                                            <a :href="$root.locale === 'de_DE' ? 'https://www.klinger.co.at/de/services/downloads?file=files/KLINGER_Dichtungstechnik/downloads/Produktinformation%20allgemein/KLINGERexpert%206.0_D.pdf&cid=1666' : '/files/KLINGER_Dichtungstechnik/downloads/KLINGERexpert 6.0_E.pdf'" target="_blank">{{'Klinger expert' | translate}}</a>
                                        </li>
                                    </ul>
                                </section>
                                
                                <section v-if="material.structures.length">
                                    <header>
                                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="link" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-link fa-w-16 fa-9x"><path fill="currentColor" d="M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z" class=""></path></svg>
                                        <h3>{{'Related links' | translate}}</h3>
                                    </header>
                                    <ul>
                                        <li>
                                            <a :href="$root.locale === 'de_DE' ? 'https://www.klinger.co.at/de/services/klinger-expert' : 'https://www.klinger.co.at/en/services/klinger-expert'" target="_blank">{{'KLINGER®expert' | translate}}</a>
                                        </li>
                                        <li>
                                            <a :href="$root.locale === 'de_DE' ? 'https://www.klinger.co.at/de/services/produktzulassungen' : 'https://www.klinger.co.at/en/services/product-approvals'" target="_blank">{{'Approval overview' | translate}}</a>
                                        </li>
                                    </ul>
                                </section>

                                <section v-if="material.chemicals.length">
                                    <header>
                                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="flask" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-flask fa-w-14 fa-9x"><path fill="currentColor" d="M437.2 403.5L320 215V64h8c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8v151L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM137.9 320l48.2-77.6c3.7-5.2 5.8-11.6 5.8-18.4V64h64v160c0 6.9 2.2 13.2 5.8 18.4l48.2 77.6h-172z" class=""></path></svg>
                                        <h3>{{'This material is chemically resistant to:' | translate}}</h3>
                                    </header>
                                    <div class="scroll-box">
                                        <ul>
                                            <li v-for="structure in chemicals">
                                                {{ getProp(structure, 'title') }}
                                            </li>
                                        </ul>
                                    </div>
                                </section>


                            </div>
                        </div>

                    </main>
                </div>
            </div>
        </article>

    </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'detail',
  components: {
    
  },
    computed: {
        material() {
            return this.$root.data[this.$route.params.id];
        },
        chemicals() { 
            return this.material && this.material.chemicals.sort((a, b) => {
                return this.getProp(a, 'title') === this.getProp(b, 'title') ? 0 : this.getProp(a, 'title').localeCompare(this.getProp(b, 'title'));
            })
        }
    },
    methods: {
        getProp(o, prop) {
            return this.$root.locale === 'de_DE' ? (o["de_" + prop] || o[prop]) : o[prop]
        }
    }
}
</script>

<style lang="scss" scoped>
p, .desc {
    color: #003a67;

    h5 {
        font-size: 16px;
        font-weight: bold !important;
        font-family: "Open Sans", Arial, sans-serif !important;
    }
}
.pt {
    padding-top: 20px;
}
.buy {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 0;
}
.buy-button {
    padding: 16px;
    border-radius: 10px;
    color: white;
    background-color: #003a67;
    font-size: 20px;
    font-weight: bold;

    svg {
        height: 30px;
        display: inline-block;
        vertical-align: middle;
        width: auto;
        margin-right: 10px;
    }
}
section {
    header {
        display: flex;
        align-items: center;
        svg {
            margin-right: 10px;
            width: 20px;
            fill: #427092;
            color: #427092;
        }
        h4 {
            font-size: 20px;
        }
        small {
            margin-top: 15px;
        }
    }
}
</style>